module.exports = __webpack_public_path__ + "media/images/logo/logo_auto-c486f9a96c067adede0f75e87dfcbeee.png";